module.exports = __webpack_public_path__ + "static/media/rossas_doughnuts.7debc23c.jpg";